import React from 'react';
import styles from './Spinner.module.css';

const Spinner: React.FC = () => {
    return (
        <svg
            className={styles.spinner}
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="iconography-/-spinner"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <path
                    className={styles.path}
                    d="M13.9272975,4.71663823 C14.2015865,4.10576932 14.9200313,3.83252181 15.5319888,4.10632283 C19.1683355,5.73329092 21.1591016,9.62552159 20.3023784,13.4571945 C19.4472703,17.2816438 15.9891482,20 12,20 C8.01085182,20 4.55272966,17.2816438 3.69762158,13.4571945 C2.84089839,9.62552159 4.83166449,5.73329092 8.46801117,4.10632283 C9.07996873,3.83252181 9.79841349,4.10576932 10.0727025,4.71663823 C10.3469914,5.32750713 10.0732569,6.0446738 9.46129939,6.31847482 C6.87111933,7.4773688 5.46398983,10.228507 6.0678208,12.9291258 C6.6732669,15.6369682 9.13973094,17.5758031 12,17.5758031 C14.8602691,17.5758031 17.3267331,15.6369682 17.9321792,12.9291258 C18.5360102,10.228507 17.1288807,7.4773688 14.5387006,6.31847482 C13.9267431,6.0446738 13.6530086,5.32750713 13.9272975,4.71663823 Z"
                    id="Path"
                    fill="#231F20"
                    fill-rule="nonzero"
                ></path>
            </g>
        </svg>
    );
};

export default Spinner;
